import React, {useState} from 'react'
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess } from '../utils/permissions';
import T from '../components/Translation';
import { dT } from '../components/Translation';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import { useQuery } from '@tanstack/react-query';
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { IoIosArrowDropdown } from "react-icons/io";
import { IoIosArrowDropright } from "react-icons/io";

const SurveyReport = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const campaignId = urlParams.get('campaignId');
    const campaignTitle = urlParams.get('campaignTitle');
    const email = urlParams.get('email');
    const surveyId = urlParams.get('_id');
    const {user} = useAuthContext(AuthContext)
    const {hideTestButtons, language, apiUrl} = useStateContext()

        const { data: survey, error: surveyError , isLoading: surveyLoading } = useQuery({
            queryKey: ['survey', surveyId],
            enabled: !!surveyId && !!apiUrl,
            queryFn: async () => {
                const response = await fetch(`${apiUrl}/surveys/${surveyId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch survey');
                }
                return response.json();
            }
        });

    const { data: surveyResponsesData, error, isLoading } = useQuery({
        queryKey: ['surveyResponses', surveyId],
        enabled: !!surveyId && !!apiUrl,
        queryFn: async () => {
            const response = await fetch(`${apiUrl}/survey-responses/by-survey/${surveyId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch survey');
            }
           
            return response.json();
        }
    });
    const surveyResponses = surveyResponsesData?.filter((r) => campaignId ? r.campaignId === campaignId : r)
    const questions = survey?.questions || []

    const allReportResponses = surveyResponses?.map((r) => 
        r?.userResponses?.map((uR) => uR?.answers?.map((a) => ({...a, campaignId: r.campaignId, questionId: uR.questionId})))?.flat())?.flat()
    const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("surveyResponses lskdlwsdkls", {surveyResponses, email, user, campaignId, survey, allReportResponses, questions})
    }

    if (!isGodMode(user)) {
        return <NoAccess />
    }

    if (isLoading || surveyLoading) { return <Loading/> }
    
    return (
        <div>
            <BlueButton 
                hide={hideTestButtons} 
                text={"Test Button"} 
                fn={testFunction}
            />
            <div style={{textAlign:"center"}}>
                <h1>{survey?.title}</h1>
            </div>
            <VisDiv rules={[email]}>
                 <UserDetails user={surveyResponses?.find((r) => r?.email === email)} questions={questions}/>
            </VisDiv>
            <div style={{textAlign:"center"}}>
                <h2>SURVEY REPORT</h2>
                <VisDiv rules={[campaignTitle]}><h3>{`CAMPAIGN: ${campaignTitle}`}</h3></VisDiv>
            </div>
            <div style={{margin: "20px 0"}}>
                <ReportLine 
                    label={"Responses"} 
                    value={Array.isArray(surveyResponses) ? surveyResponses.length : 0}
                />
                {questions?.filter((q) => q.type === "radio" || q.type === "multiple")?.map((q) => {
                    return (
                        <QuestionResponse 
                            question={q}     
                            key={q._id}
                            responses={allReportResponses?.filter((r) => r.questionId === q._id)}
                        />
                    )
                })}
            </div>
            <div style={{margin: "20px 0"}}>
                <h3 style={{padding: "20px", textAlign:"center"}}>RESPONSE USERS:</h3>
                {Array.isArray(surveyResponses) && surveyResponses?.map((response) => {
                    return (
                        <div key={response._id} style={{margin: "20px 0"}}>
                            <ResponseUser response={response} questions={questions}/>
                        </div>
                    )
                })}
            </div>
 
        </div>
    )
}

export default SurveyReport

export const ReportLine = ({label, value, justifyContent="left"}) => {
    return (
        <div style={{display:"flex", justifyContent, padding: "10px", borderBottom: "1px solid #ccc", margin: "5px 0"}}>
            <div>{label}:</div>
            <div style={{fontWeight:"bold", marginLeft: "10px"}}>{value}</div>
        </div>
    )
}

export const ResponseUser = ({response, questions}) => {
    const [viewUserDetails, setViewUserDetails] = useState(false)
    return (
        <VisDiv onClick ={() => setViewUserDetails(!viewUserDetails)}>
            <div style={{display:"flex", justifyContent:"left", padding: "10px", border: "1px solid #ccc", margin: "10px 0"}}>
                <div style={{display:"flex", justifyContent:"left", alignItems:"center", flex:1}}>
                    <DropArrow style={{marginRight: "5px"}} state={viewUserDetails}/>
                    <div style={{marginRight: "5px"}}>{response?.firstName}</div>
                    <div style={{marginRight: "20px"}}>{response?.lastName}</div>
                </div>

                <div style={{marginRight: "10px", flex: 3}}>{response?.email}</div>
            </div>
            <VisDiv rules={[viewUserDetails]}>
                <UserDetails user={response} questions={questions}/>
            </VisDiv>
        </VisDiv>
    )
}

export const UserDetails = ({user, questions=[]}) => {
    return (
        <div style={{display:"flex", flexDirection:"column", justifyContent:"left", padding: "10px", borderBottom: "1px solid #ccc", margin: "10px 0"}}>
            <ReportLine label={"First Name"} value={user?.firstName}/>
            <ReportLine label={"Last Name"} value={user?.lastName}/>
            <ReportLine label={"Professional Title"} value={user?.professionalTitle}/>
            <ReportLine label={"Email"} value={user?.email}/>
            <ReportLine label={"Phone Number"} value={user?.phoneNumber}/>
            <ReportLine label={"Created"} value={user?.createdAt}/>
            <ReportLine label={"Country"} value={user?.country?.label}/>
            <ReportLine label={"City"} value={user?.city?.label}/>
            {/* <h3 style={{padding: "20px"}}>RESPONSES:</h3> */}
            {user?.userResponses?.map((response) => {
                const question = questions?.find(q => q._id === response.questionId)
                return (
                    <div key={response._id} style={{}}>
                        <ReportLine label={question?.title} value={response?.answers?.map((answer) => answer.answerText).join(", ")}/>
                    </div>
                )
            })}

        </div>
    )
}

export const QuestionResponse = ({question, responses=[]}) => {
    const [viewDetails, setViewUserDetails] = useState(true)
    const questionResponses = responses?.filter((r) => r.questionId === question?._id)?.length
    return (
        <VisDiv onClick ={() => setViewUserDetails(!viewDetails)}>
            <div style={{display:"flex", justifyContent:"left", alignItems:"center", padding: "10px", border: "1px solid #ccc", margin: "10px 0"}}>
                <DropArrow style={{marginRight: "5px"}} state={viewDetails}/>
                <div style={{marginRight: "10px"}}>{question?.title}</div>
                <div style={{fontWeight:"bold", marginLeft: "0px"}}>{questionResponses}</div>
                
            </div>
            <VisDiv rules={[viewDetails]}>
                {question?.answerOptions?.map((option) => {
                    const count = responses?.filter((r) => r.answerId === option?.answerId)?.length
                    return (
                        <div key={option._id} style={{marginLeft: "20px"}}>
                            <ReportLine label={option?.answerText} value={count}/>
                        </div>
                    )
                })}
            </VisDiv>
        </VisDiv>
    )
}

export const DropArrow = ({state = true, style}) => {
    return (
    <div style={{...style, cursor:"pointer"}}>
        {!state ? <IoIosArrowDropright size={25}/> : <IoIosArrowDropdown size={25}/>}
    </div>)

}